import * as Sentry from '@sentry/react';
import { isSentryEnabled, SENTRY_DSN } from './isSentryEnabled';

export function initSentry() {
  if (!isSentryEnabled) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    tracesSampleRate: 1,
  });
}
